import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { MaterialTabItem } from '@nimbus-library/features/shared/components/material/mat-tabs/material-tab/material-tab-item.model';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';

@Component({
  standalone: false,
  selector: 'nimbus-material-tab',
  templateUrl: 'material-tab.component.html',
  styleUrls: ['./material-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialTabComponent {
  @Input()
  public model: MaterialTabItem;
  @Input()
  public disabledMessage?: string;
  @Input()
  public tooltipText?: string;

  @Output()
  public tabSelect: EventEmitter<void> = new EventEmitter<void>();

  @HostBinding('class')
  public class: string = 'nimbus-tab-item';

  public icons = ICONS;

  @HostBinding('attr.id')
  public get id(): string {
    return this.model ? this.model.id : null;
  }

  @HostBinding('class.active')
  public get isActive(): boolean {
    return this.model ? this.model.isActive : false;
  }

  @HostBinding('class.invalid')
  public get isInvalid(): boolean {
    return this.model ? this.model.isInvalid : false;
  }

  @HostBinding('class.warning')
  public get hasWarning(): boolean {
    return this.model ? this.model.hasWarnings : false;
  }

  @HostBinding('class.hidden')
  public get isHidden(): boolean {
    return this.model ? !this.model.isVisible : false;
  }

  @HostBinding('class.disabled')
  public get isDisabled(): boolean {
    return this.model ? this.model.isVisible && this.model.isDisabled : false;
  }
  @HostListener('click')
  public onClick(): void {
    if (!this.isDisabled) {
      this.tabSelect.emit();
    }
  }

  public TranslationKeys = TranslationKeys;
}
